// Import the functions you need from the SDKs you need
import { getApp, getApps, initializeApp, type FirebaseApp } from "firebase/app";
import { doc, getDoc, collection, addDoc, getDocs, where, query, increment, setDoc } from "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import * as firestore from "firebase/firestore";
import type { vehicleSubscription, ContactForm, InfoRequest } from "./types";
import { json } from "@sveltejs/kit";
import { isLive } from "$lib";

const firebaseConfig = {
    apiKey: import.meta.env.VITE_APIKEY,
    authDomain: import.meta.env.VITE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_APP_ID,
};
// Initialize Firebase app if it's not already initialized
let app: FirebaseApp;

if (getApps().length === 0) {
    app = initializeApp(firebaseConfig);
} else {
    app = getApp();
}

export const db = getFirestore(app);
export const auth = getAuth(app);
export { firestore, firebaseConfig };

export async function getStripeCustomerId(email: string) {
    const userRef = await doc(db, "stripeCustomers", email);
    const querySnapshot = await getDoc(userRef);
    return querySnapshot.data().stripeCustomerId;
}
export async function getStripeCustomerEmailById(stripeId: string) {
    const stripeCustomersCollection = collection(db, "stripeCustomers");
    const q = query(stripeCustomersCollection, where("stripeCustomerId", "==", stripeId));
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs[0].data().c_email;
}
export async function addWebhookDataToStripeCustomer(customerId: string, subCollection: string, data: any) {
    console.log("addWebhookDataToStripeCustomer", customerId, subCollection, data);

    const email = await getStripeCustomerEmailById(customerId);
    const userRef = await doc(db, "stripeCustomers", email);
    // stripeCustomers/steven@allusionsoftware.com/webhookData/checkout.session.complete/{CHECKOUT_SESSION_ID}
    const collectionRef = await collection(userRef, "webhookData", subCollection, data.object.id);
    await addDoc(collectionRef, data.object);
    if (subCollection === "checkout.session.complete") {
        await sendWelcomeEmail(email);
    }
    console.log("added webhook data");
}
export async function addSubscriptionToStripeCustomer(email: string, subscriptionData: vehicleSubscription) {
    console.log("addSubscriptionToStripeCustomer", email, subscriptionData);
    // const userRef = await doc(db, "stripeCustomers", email);
    // const collectionRef = await collection(userRef, "subscriptions");
    // const newDocRef = await addDoc(collectionRef, subscriptionData);
    // return newDocRef.id;
}
export async function sendWelcomeEmail(email: string) {
    const userRef = await doc(db, "stripeCustomers", email);
    if (!userRef) return { message: "User not found" };
    const querySnapshot = await getDoc(userRef);
    const firstName = querySnapshot.data().c_fname;
    const lastName = querySnapshot.data().c_lname;
    const c_name = firstName + " " + lastName;
    const temp_password = querySnapshot.data().temp_password;
    console.log("sending email to : ", firstName, lastName, temp_password);
    const response = await fetch("/api/email/welcome", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email, c_name: c_name, temp_password: temp_password }),
    });
    let data = await response.json();
    return data;
}
export async function saveReferredLemonSquadOrder(data: any) {
    // console.log("captureReferrerInfo", data);
    console.log("orderid", data.o_id);
    const collectionRef = collection(db, "lemon-squad-referred-orders");
    //check if order already exists
    const q = query(collectionRef, where("o_id", "==", data.order.o_id));
    const querySnapshot = await getDocs(q);
    if (querySnapshot.empty) {
        await addDoc(collectionRef, data);
        console.log("added referrer info");
    } else {
        console.log("referrer info already exists");
    }
}
export async function captureInfoRequest(data: InfoRequest) {
    const collectionRef = collection(db, "autocerts-info-requests");
    const docData = {
        timestamp: new Date().toISOString(),
        ...data
    }
    await addDoc(collectionRef, docData);
}
export async function captureReferrerClickThrough(order_id: string, order: any) {
    // const collectionRef = collection(db, "autocerts-clickthroughs");
    const docRef = doc(db, "autocerts-clickthroughs", order_id);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) {
        await setDoc(docRef, { order_id: order_id, timestamp: Date.now(), sessions: 1, order });
    } else {
        await firestore.updateDoc(docRef, { sessions: increment(1) });
    }
    console.log("captured referrer clickthrough");
}
//=============================================== contact form ===============================================
let contactFormCollection = isLive ? "autocerts-contact-form" : "autocerts-contact-form-dev";
export async function captureContactForm(data: ContactForm) {
    try {
        const collectionRef = collection(db, contactFormCollection);
        await addDoc(collectionRef, data);
        console.log("captured contact form");
        return new Response(JSON.stringify({ message: "success" }), { status: 200 });
    } catch (error) {
        console.error("Error capturing contact form", error);
        return new Response(JSON.stringify({ message: "error saving contact form" }), { status: 500 });
    }
}
//=============================================== end contact form ===============================================